var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7087 9.37501V7.29168C17.7087 4.37501 15.417 2.08334 12.5003 2.08334C9.58366 2.08334 7.29199 4.37501 7.29199 7.29168V9.37501C5.52116 9.37501 4.16699 10.7292 4.16699 12.5V19.7917C4.16699 21.5625 5.52116 22.9167 7.29199 22.9167H17.7087C19.4795 22.9167 20.8337 21.5625 20.8337 19.7917V12.5C20.8337 10.7292 19.4795 9.37501 17.7087 9.37501ZM9.37533 7.29168C9.37533 5.52084 10.7295 4.16668 12.5003 4.16668C14.2712 4.16668 15.6253 5.52084 15.6253 7.29168V9.37501H9.37533V7.29168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.02220106ceeb0c4aebbe5e50820dea39.svg";
export { ForwardRef as ReactComponent };